import React from 'react'
import styled, { css } from 'styled-components'
import { LocalizedLink as Link, useTranslation } from '../../lib/i18n'
import desktop from './img/desktop.webp'
import graph from './img/graph.webp'
import lock from './img/lock.webp'
import trophy from './img/trophy.webp'
import { small, large } from '../../lib/media_query'
import { FaArrowCircleRight } from 'react-icons/fa'
import PlusBadge from '../../common/plus_badge'

const Wrapper = styled.div`
    > .cell {
        display: flex;
        justify-content: center;
        margin-bottom: 20px;
        perspective: 1000px;

        ${small(css`
            &:last-child {
                margin-bottom: 0px;
            }
        `)}

        > div {
            width: 190px;
            transform-style: preserve-3d;
        }

        h3 {
            text-align: center;
            font-size: 1rem;
        }

        img {
            opacity: 0.8;
            margin-bottom: 20px;
            border-radius: 8px;
            border-bottom: 1px solid ${(props) => props.theme.palette.greyScale.lightGrey};
            transition: opacity 0.3s ease, transform 0.3s ease;
        }

        ${large(css`

            img {
                opacity: 0.6;
            }

            &:hover img {
                opacity: 0.9;
            }

            &:nth-child(1) img {
                transform: rotateY(10deg);
            }

            &:nth-child(1):hover img {
                transform: rotateY(5deg) translateY(-5px);
            }

            &:nth-child(2) img {
                transform: rotateY(5deg) scale(0.95) translateY(4px);
            }

            &:nth-child(2):hover img {
                transform: rotateY(0deg) scale(1) translateY(-5px);
            }

            &:nth-child(3) img {
                transform: rotateY(-5deg) scale(0.95) translateY(4px);
            }

            &:nth-child(3):hover img {
                transform: rotateY(0deg) scale(1) translateY(-5px);
            }

            &:nth-child(4) img {
                transform: rotateY(-10deg);
            }

            &:nth-child(4):hover img {
                transform: rotateY(-5deg) translateY(-5px);
            }
        `)}


        p {
            color: ${({ theme }) => theme.palette.greyScale.grey};
            text-align: center;
        }

        a.button.privacy {
            margin: 0px;
            padding: 0px;
            display: inline-flex;
            align-items: center;
            gap: 6px;
        }
    }
`

export default () => {
    const { t } = useTranslation(undefined, { keyPrefix: 'home.product.boxes' })

    return (
        <Wrapper className="grid-x align-justify">
            <div className="cell large-3 small-12 medium-6">
                <div>
                    <img className="box-shadow" src={desktop} alt={t('distractionFree.alt')} />
                    <h3>{t('distractionFree.title')}</h3>
                    <p>{t('distractionFree.body')}</p>
                </div>
            </div>
            <div className="cell large-3 small-12 medium-6">
                <div>
                    <img className="box-shadow" src={graph} alt={t('trackProgress.alt')} />
                    <h3>{t('trackProgress.title')} <PlusBadge /></h3>
                    <p>{t('trackProgress.body')}</p>
                </div>
            </div>
            <div className="cell large-3 small-12 medium-6">
                <div>
                    <img className="box-shadow" src={trophy} alt={t('streak.alt')} />
                    <h3>{t('streak.title')} <PlusBadge /></h3>
                    <p>{t('streak.body')}</p>
                </div>
            </div>
            <div className="cell large-3 small-12 medium-6">
                <div>
                    <img className="box-shadow" src={lock} alt={t('private.alt')} />
                    <h3>{t('private.title')}</h3>
                    <p>{t('private.body')}</p>
                    <p>
                        <Link to="/privacy" className="button clear secondary privacy">
                            <FaArrowCircleRight /> {t('private.link')}
                        </Link>
                    </p>
                </div>
            </div>
        </Wrapper>
    )
}
